<template>
  <div class="creative-assets">
    <div class="scroll-wrapper">
      <el-form class="filter-form elementui-common-form-styles" v-highlight ref="assets-form" inline label-width="62px">
        <el-form-item>
          <span slot="label">游&emsp;戏</span>
          <ThrottleSelector
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="form.game_id"
            :list="games"
            style="width: 200px"
            placeholder="全部"
            filterable
            clearable
            @change="form.imageStyleList = []"
          />
        </el-form-item>

        <el-form-item label="游戏组">
          <el-select
            v-model="form.game_group_id"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            style="width: 200px"
            filterable
            clearable
            placeholder="全部"
            @change="onGameGroupChange"
          >
            <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传者">
          <ThrottleSelector
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="form.up_op_id"
            style="width: 200px"
            :list="ptomUsers"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>

        <el-form-item v-if="$scopedSlots.mediatag">
          <span slot="label">媒体标签</span>
          <slot name="mediatag" :getData="queryPage" width="200px"></slot>
        </el-form-item>

        <template v-if="form.media_id && Number(form.media_id) === MEDIAS.TOUTIAO">
          <el-form-item label="素材筛选">
            <el-select
              v-model="form.toutiaoLabel"
              popper-class="creative-selector-el-select-popper"
              :popper-append-to-body="false"
              style="width: 200px"
              multiple
              collapse-tags
              clearable
              placeholder="全部"
            >
              <el-option v-for="item in toutiaoMaterialIncludeLabel" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="素材过滤">
            <el-select
              v-model="form.toutiaoLabelExclude"
              popper-class="creative-selector-el-select-popper"
              :popper-append-to-body="false"
              style="width: 200px"
              multiple
              collapse-tags
              clearable
              placeholder="全部"
            >
              <el-option v-for="item in toutiaoMaterialExcludeLabel" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item>
          <span slot="label">内容标签</span>
          <ThrottleSelector
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="form.label_ids"
            @change="queryPage"
            :list="contentSysTags"
            style="width: 200px"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>
        <el-form-item label="素材样式">
          <el-cascader
            v-model="form.imageStyleList"
            clearable
            filterable
            collapse-tags
            style="width: 200px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="labelFormData.game.length > 0 ? filterdImageStyleTagList : imageStyleTagTreeList"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item v-if="$scopedSlots.sizes">
          <span slot="label">尺&emsp;寸</span>
          <slot name="sizes" :getData="queryPage" width="200px"></slot>
        </el-form-item>

        <el-form-item label="消耗情况">
          <el-cascader
            v-model="form.amountType"
            clearable
            filterable
            collapse-tags
            style="width: 200px"
            :show-all-levels="false"
            :props="{ multiple: true }"
            :options="HAS_AMOUNT_TYPES"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="使用情况">
          <el-cascader
            v-model="form.planType"
            clearable
            filterable
            collapse-tags
            style="width: 200px"
            :show-all-levels="false"
            :props="{ multiple: true }"
            :options="HAS_PLAN_TYPES"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="上传时间">
          <DateRangePicker v-model="form.uploadDateRange" @change="queryPage" style="width: 200px"></DateRangePicker>
        </el-form-item>

        <el-form-item label="关键词">
          <el-input
            style="width: 200px"
            @input="queryPage"
            @keyup.enter.native="queryPage"
            v-model="form.keyword"
            clearable
            placeholder="输入关键词搜索"
          >
            <i slot="append" @click="queryPage" class="el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="bg-transparent" style="padding-left: 0">
          <el-button @click="queryPage" :loading="pageLoading" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <div class="toggle-row">
        <div class="assets-type">
          <slot name="assetType" :getData="queryPage">
            <!-- 默认素材为视频类型 -->
            <el-radio :value="assetType" @change="queryPage" :label="VIDEO">视频</el-radio>
          </slot>
        </div>

        <div class="assets-display" v-if="showTableLayout">
          <div class="table-layout" v-if="layoutType === TABLE_LAYOUT">
            <DateRangePicker v-model="dateTime" @change="queryPage" :clearable="false" size="mini" style="width: 220px"></DateRangePicker
            >&ensp;
          </div>
          <span
            @click="onLayoutToggle(GRID_LAYOUT)"
            :style="{ color: layoutType === GRID_LAYOUT ? '#1974ff' : null }"
            class="toggle-icon el-icon-s-grid"
          ></span>
          <span
            @click="onLayoutToggle(TABLE_LAYOUT)"
            :style="{ color: layoutType === TABLE_LAYOUT ? '#1974ff' : null }"
            class="toggle-icon el-icon-s-data"
          ></span>
        </div>
      </div>

      <!-- 头条图文素材账号筛选 -->
      <slot name="carouselAccount" :getData="queryPage"></slot>

      <div style="display: flex">
        <div v-loading="pageLoading">
          <div class="assets-content">
            <!-- 宫格展示 -->
            <AssetGridLayout v-show="layoutType === GRID_LAYOUT" v-model="selectedRows" :max="max">
              <GridItem v-for="grid in gridData" :key="grid.id" :grid="grid">
                <!-- 视频显示封面 -->
                <template v-if="['video'].includes(grid.type)">
                  <img loading="lazy" :class="getGridLayoutClass(grid)" :src="grid.preview_url" />
                </template>

                <!-- 图文 -->
                <img v-else-if="[IMAGE_AUDIO].includes(assetType)" :class="getGridLayoutClass(grid)" loading="lazy" :src="grid.url" />

                <img
                  v-if="['image', 'image_list', 'poster', 'logo', 'sticker'].includes(grid.type)"
                  loading="lazy"
                  :class="getGridLayoutClass(grid)"
                  :src="grid.url"
                />

                <!-- 音频 -->
                <template v-if="assetType === AUDIO">
                  <audio class="audio-player" preload="none" :src="grid.url"></audio>
                </template>

                <!-- 个人收藏按钮，只支持视频、图片-->
                <div slot="action-btn" class="action-btn" v-if="[VIDEO, META, IMAGE, GROUP_IMAGE, FAV].includes(assetType) || analysisType">
                  <div class="favorite" @click.stop="onFavoriteStateChange(grid)">
                    <em class="el-icon-star-on" v-if="grid.isFavor === 1"></em>
                    <em class="el-icon-star-off" v-else></em>
                    <span>收藏</span>
                  </div>

                  <template>
                    <div class="zoom">
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        :close-delay="500"
                        @show="set(grid, 'videoVisible', true)"
                        @after-leave="set(grid, 'videoVisible', false)"
                      >
                        <div v-if="grid.type === 'video'" :style="getGridLayoutStyle(grid)">
                          <video v-if="grid.videoVisible" style="height: 100%" autoplay preload="auto" controls :src="grid.url"></video>
                        </div>

                        <el-image v-else :src="grid.url" :style="getGridLayoutStyle(grid)"> </el-image>
                        <span slot="reference" class="el-icon-zoom-in"></span>
                      </el-popover>
                    </div>
                  </template>

                  <!-- analysisType -->
                  <template v-if="[VIDEO, META].includes(assetType)">
                    <div v-if="analysisType === ANALYSIS_TYPE.SEGMENT" @click.stop="onQueryMaterialAnalysisResult(grid)">
                      <em class="el-icon-c-scale-to-original"></em>
                      <span v-if="grid.extractSlices === ANALYSIS_STATUS.EXTRA_SLICE_COMPLETED">查看分析片段</span>
                      <span v-else>点击识别片段</span>
                    </div>
                    <div
                      v-if="analysisType === ANALYSIS_TYPE.TOP_MATERIAL && selectedRows.length === 1 && selectedRows[0].id === grid.id"
                      @click.stop="onQueryMaterialAnalysisResult(grid)"
                    >
                      <em class="el-icon-receiving"></em>
                      <span v-if="grid.popularAnalysis === ANALYSIS_STATUS.POP_ANALYSIS_COMPLETED">查看爆款拆解</span>
                      <span v-else>点击拆解爆款</span>
                    </div>
                  </template>
                </div>

                <template #analysis-tag v-if="analysisType">
                  <span v-show="grid.popularAnalysis === ANALYSIS_STATUS.POP_ANALYSIS_COMPLETED" class="analysis-tag">已拆解</span>
                  <span v-show="grid.extractSlices === ANALYSIS_STATUS.EXTRA_SLICE_COMPLETED" class="analysis-tag">已识别</span>
                </template>
              </GridItem>
            </AssetGridLayout>

            <!-- 表格展示 -->
            <AssetTableLayout
              v-show="layoutType === TABLE_LAYOUT"
              v-model="selectedRows"
              :max="max"
              :data="tableData"
              @sort-change="onTableSortChange"
            />
          </div>
        </div>

        <div class="material-analysis-wrapper" v-if="$scopedSlots.materialAnalysis && gridPager.total > 0">
          <slot
            name="materialAnalysis"
            :loading="analysisInfoLoading"
            :analysisInfo="analysisInfo"
            :update="() => onQueryMaterialAnalysisResult(currGrid)"
            :select="onSegmentSelect"
          ></slot>
        </div>
      </div>
    </div>
    <div class="pager-row">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pager.page_id"
        :page-size.sync="pager.page_size"
        :page-sizes="[20, 60, 100]"
        :total="pager.total"
        @current-change="queryDataByLayout"
        @size-change="queryPage"
      >
      </el-pagination>
    </div>
    <div class="bottom-row">
      <!-- 已选结果 -->
      <div class="results-info">
        <span>
          已选择{{ allSelectedItems.length }} <span v-if="max >= 0">/{{ this.max }} </span>
        </span>
        <el-button type="text" @click="onCurrPageItemsSelectAll">当前页全选</el-button>
        <el-button type="text" @click="selectedRows = []">清空</el-button>
        <el-button type="text" @click="onSelectedAddToFavorite" :loading="favoriteLoading" :disabled="!selectedIds.length">
          一键收藏
        </el-button>
      </div>

      <div class="results">
        <Draggable class="drag-wrapper" :value="selectedRows" :move="onSelectedItemDragMove" @end="onSelectedItemDragEnd">
          <span class="results-item" :title="img.name" v-for="img in allSelectedItems" :key="img.id">
            <el-avatar shape="square" v-if="img.preview_url" :size="60" fit="cover" :src="img.preview_url"></el-avatar>
            <!-- 素材分析选择的切片 -->
            <div class="analysis-segment" v-if="img.content_title">
              <span class="segment-label">切片</span>
              <el-avatar shape="square" :size="60" fit="cover" :src="img.cover_url"></el-avatar>
            </div>
            <!-- 片段没有id字段, 用id来区分是素材还是片段 -->
            <span class="remove-icon el-icon-error" @click="img.id ? onSelectedItemRemove(img) : onSelectedSegmentRemove(img)"></span>
          </span>
        </Draggable>
      </div>

      <div class="btns">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :disabled="!allSelectedItems.length">确定</el-button>
      </div>
    </div>

    <el-dialog width="420px" title="AI识别配置" :visible.sync="aiAnalysisConfigModal" append-to-body>
      <el-form label-width="110px" :model="analysisInstructionForm" :rules="analysisInstructionFormRules" ref="analysisInstructionFormRef">
        <el-form-item label="识别指令" prop="instruction">
          <el-select v-model="analysisInstructionForm.instruction" style="width: 100%" value-key="title" placeholder="请选择识别指令">
            <el-option label="自定义" :value="{ title: '自定义' }"></el-option>
            <el-option
              v-for="config in analysisInstructionConfigList"
              :key="config.title"
              :label="config.title"
              :value="config"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="analysisInstructionForm.instruction.title === '自定义'" label="自定义指令" prop="customInstruction">
          <el-input
            type="textarea"
            rows="4"
            v-model="analysisInstructionForm.customInstruction"
            placeholder="请输入自定义指令"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onAnalysisConfigCancel">取 消</el-button>
        <el-button type="primary" @click="onAnalysisConfigConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, watch, set, ref } from 'vue'
import { Message } from 'view-design'
import { MEDIAS } from '@/common/js/constants.js'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import AssetGridLayout, { GridItem } from './grid/index.js'
import AssetTableLayout from './table.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import Draggable from 'vuedraggable'
import toutiaoMaterialIncludeLabel, { toutiaoMaterialExcludeLabel } from '@/views/material/data/toutiao_label.js'
import {
  useGrid,
  useMaterialFavorite,
  useMaterialAnalysis,
  useVideoElementDisplay,
  useSelectedMaterialActions,
  IMAGE,
  GROUP_IMAGE,
  VIDEO,
  META,
  AUDIO,
  LOGO,
  STICKER,
  POSTER,
  FAV,
  IMAGE_AUDIO,
  GRID_LAYOUT,
  TABLE_LAYOUT
} from './hooks/useSelector.js'
import { useLabels } from '@/views/material/uploading/hooks/useLabelRelations.js'
import { initPageData, GAME_GROUPS, GAMES, PTOM_USERS, CONTENT_SYS_TAGS, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
import { ANALYSIS_TYPE, ANALYSIS_STATUS } from '@/views/creatives/const.js'
import { HAS_AMOUNT_TYPES, HAS_PLAN_TYPES } from '@/views/material/library/const.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object,
  visible: Boolean,
  assetType: [Number, String],
  analysisType: { type: Number, default: 0 },
  videoId: { type: Number, default: 0 },
  selectedGameId: { type: [Number], default: 0 },
  adAccountId: { type: Number, default: 0 },
  max: Number, // 最多可选择多少个素材,-1代表不限
  beforeSubmit: Function
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'update:visible', 'close', 'confirm'])

const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES, PTOM_USERS, CONTENT_SYS_TAGS, IMAGE_STYLE_TAG_TREE])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const games = computed(PAGE_REQUIRED_OPTS.GAMES)
const ptomUsers = computed(PAGE_REQUIRED_OPTS.PTOM_USERS)
const contentSysTags = computed(PAGE_REQUIRED_OPTS.CONTENT_SYS_TAGS)

// 如果有选择游戏或游戏组，获取全部的游戏id来过滤素材样式标签，如果没有选择任何游戏、游戏组，显示全部的素材样式树形结构
const groupGameIds = ref([])
const labelFormData = computed(() => ({ game: [props.form.game_id, ...groupGameIds.value].filter(Boolean).map(Number) }))
const { imageStyleTagTreeList, imageStyleTagList: filterdImageStyleTagList } = useLabels(labelFormData)

const {
  layoutType,
  pageLoading,
  gridData,
  tableData,
  selectedRows,
  selectedIds,
  dateTime,
  pager,
  gridPager,
  showTableLayout,
  getGridLayoutClass,
  getGridLayoutStyle,
  queryPage,
  queryDataByLayout,
  onLayoutToggle,
  onTableSortChange,
  setSelectedRows
} = useGrid(props, emit)
const { onGridElementMouseEnter, onGridElementMouseLeave } = useVideoElementDisplay()
const { onCurrPageItemsSelectAll, onSelectedItemRemove, onSelectedItemDragMove, onSelectedItemDragEnd } = useSelectedMaterialActions(
  props,
  gridData,
  tableData,
  layoutType,
  selectedRows
)
const { favoriteLoading, onFavoriteStateChange, onSelectedAddToFavorite } = useMaterialFavorite(props, gridData, selectedRows, queryPage)
const {
  currGrid,
  aiAnalysisConfigModal,
  analysisInfoLoading,
  analysisInfo,
  selectedSegments,
  resetAnalysisInfo,
  analysisInstructionFormRef,
  analysisInstructionFormRules,
  analysisInstructionConfigList,
  analysisInstructionForm,
  onAnalysisConfigConfirm,
  onAnalysisConfigCancel,
  onSegmentSelect,
  onSelectedSegmentRemove,
  onQueryMaterialAnalysisResult
} = useMaterialAnalysis(props, queryDataByLayout)

const allSelectedItems = computed(() => [...selectedRows.value, ...selectedSegments.value])

/**
 * @description: 获取游戏组下的所有游戏id，用于过滤素材样式标签
 * @param {*} groupId
 * @return {*}
 */
const onGameGroupChange = (groupId) => {
  if (!groupId) {
    groupGameIds.value = []
    return
  }
  const { gameIds } = gameGroups.value.find((item) => groupId === item.id) || {}
  if (gameIds) {
    groupGameIds.value = [...gameIds]
  }
  props.form.imageStyleList = []
}

const onSubmit = () => {
  let analysisData = []
  // 把爆款视频解析结果加到选中的素材中
  // 爆款素材不需要校验素材个数, 爆款素材只能选择一个
  if (props.analysisType > 0) {
    if (props.analysisType === ANALYSIS_TYPE.TOP_MATERIAL) {
      const [video] = selectedRows.value
      analysisData = [{ ...video, analysisTaskResult: analysisInfo.value.analysisResult }, ...selectedSegments.value]
    } else {
      if (allSelectedItems.value.length > props.max) {
        return Message.error(`最多可选择${props.max}个素材`)
      }
    }
  }

  const submitData = analysisData?.length ? analysisData : allSelectedItems.value

  if (typeof props.beforeSubmit === 'function') {
    props.beforeSubmit(submitData, {
      done: () => {
        emit('confirm', submitData)
        onCancel()
      },
      fail: (failMsg) => {
        Message.error(failMsg)
      }
    })
  } else {
    emit('confirm', submitData)
    onCancel()
  }
}

const onCancel = () => {
  emit('update:visible', false)
  emit('close')
  resetAnalysisInfo()
}

watch(
  () => selectedRows.value,
  () => {
    // 爆款拆解时，切换素材清空爆款拆解信息
    if (props.analysisType === ANALYSIS_TYPE.TOP_MATERIAL) {
      const [selectItem] = selectedRows.value
      if (selectItem && selectItem.popularAnalysis === ANALYSIS_STATUS.POP_ANALYSIS_COMPLETED) {
        onQueryMaterialAnalysisResult(selectItem)
      }

      resetAnalysisInfo()
    }
  }
)

watch(
  () => props.visible,
  (val) => {
    if (val) {
      queryPage()
    } else {
      selectedRows.value = []
      selectedSegments.value = []
      gridData.value = []
      setTimeout(() => {
        layoutType.value = GRID_LAYOUT
      }, 500)
    }
  },
  { immediate: true }
)
// eslint-disable-next-line
defineExpose({
  setSelectedRows
})
</script>

<style lang="scss">
// 下拉框位置错乱了，使用absolute重新定位
.creative-selector-el-select-popper {
  &.el-select-dropdown {
    position: absolute !important;
    top: 30px !important;
    left: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.creative-assets {
  .filter-form {
  }
  .scroll-wrapper {
    width: 1170px;
    height: 720px;
    overflow: auto;
  }
  .assets-content {
    // height: 100%;
    width: 1160px;
  }

  .material-analysis-wrapper {
    min-width: 380px;
    max-width: 380px;
    flex: 1;
  }
  ::v-deep .asset-item {
    &:hover {
      .action-btn {
        display: flex;
      }
    }
  }
  .analysis-tag {
    background: rgba(255, 255, 255, 0.8);
    padding: 2px;
    font-size: 12px;
    border-radius: 2px;
    color: green;

    &:nth-child(2) {
      color: orangered;
      margin-left: 2px;
    }
  }
  .action-btn {
    display: none;
    align-items: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 42px;
    z-index: 10;
    color: rgb(247, 186, 42);
    background: rgba(0, 0, 0, 0.6);
    padding: 4px 10px;
    .favorite {
      em {
        position: relative;
        top: -1px;
      }
    }
    .zoom {
      .el-icon-zoom-in {
        font-size: 15px;
      }
    }

    em {
      cursor: pointer;
      display: inline-block;
      font-size: 18px !important;
    }
    > div {
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
  }

  .pager-row {
    text-align: right;
    margin-top: 5px;
  }
  .bottom-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .results-info {
    width: 420px;
    position: absolute;
    top: -28px;
    left: 0;
    z-index: 1;
    font-size: 12px;
    span {
      margin-right: 10px;
    }
  }
  .results {
    font-size: 0;
    width: 100%;
    max-width: 900px;
    padding-top: 14px;
    padding-bottom: 2px;
    overflow: auto;

    .drag-wrapper {
      display: flex;
      gap: 5px;

      .analysis-segment {
        position: relative;
        .segment-label {
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          font-size: 12px;
          text-align: center;
        }
      }
    }

    &-item {
      position: relative;
      cursor: move;
      .remove-icon {
        font-size: 14px;
        cursor: pointer;
        position: absolute;
        top: -6px;
        right: -8px;
        z-index: 1;
        color: red;
        display: none;
        &:hover {
          color: rgb(227, 0, 0);
        }
      }
      &:hover {
        .remove-icon {
          display: block;
        }
      }
      ::v-deep .el-avatar {
        img {
          max-width: 100%;
          margin: 0 auto;
        }
      }
    }
  }

  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8f8f8;
    padding: 4px 6px;
    height: 36px;
    border-radius: 2px;
    margin: 5px 0 0 0;
    ::v-deep .assets-type {
      .el-radio__input.is-checked .el-radio__inner::after {
        transform: translate(-47%, -61%) scale(1);
      }
    }
    .assets-display {
      display: flex;
      align-items: center;
      .table-layout {
        display: flex;
        align-items: center;
      }
      .toggle-icon {
        cursor: pointer;
        font-size: 20px;
        line-height: 20px;
        opacity: 0.8;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>
